import React, {Component} from 'react';
import Loader from "../Spinner";
import "./style.scss"

export default ()=> <div className={'pre-loader'}><Loader/></div>